<script>
export default {
  name: 'has-filters',
  computed: {
    currentViewNameForFilters () {
      return this.$options.name + '-' + this.$route.path.replace(/[^a-z0-9]/gmi, '');
    }
  },
  data () {
    return {
      initialFilterValues: {}
    };
  },
  beforeMount () {
    this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
    this.loadFilters();
  },
  mounted () {
    this.$bus.$on('view-filters-save', this.saveFilters);
    this.$bus.$on('view-filters-reset', this.resetFilters);
  },
  methods: {
    loadFilters () {
      if (!localStorage.getItem('headwear-szwalnia-filters-' + this.currentViewNameForFilters)) {
        this.resetFilters();
        return;
      }

      let filtersData = JSON.parse(localStorage.getItem('headwear-szwalnia-filters-' + this.currentViewNameForFilters));
      this.filters = JSON.parse(JSON.stringify(filtersData));
    },
    saveFilters () {
      localStorage.setItem('headwear-szwalnia-filters-' + this.currentViewNameForFilters, JSON.stringify(this.filters));
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-filters-save', this.saveFilters);
    this.$bus.$off('view-filters-reset', this.saveFilters);
  }
}
</script>
